import { inject, Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Router } from "@angular/router";
import { filter, firstValueFrom } from "rxjs";
import { RouteData } from "../app-routing.module";
import { AuthService } from "../services/auth.service";

@Injectable({
  providedIn: "root",
})
export class SpecialtyGuard {
  private readonly router = inject(Router);

  private auth = inject(AuthService);

  public async canActivate(routeSnapshot: ActivatedRouteSnapshot) {
    return await this.checkForRequiredSpecialties(routeSnapshot);
  }

  public async canActivateChild(routeSnapshot: ActivatedRouteSnapshot) {
    return await this.checkForRequiredSpecialties(routeSnapshot);
  }

  private async checkForRequiredSpecialties(routeSnapshot: ActivatedRouteSnapshot) {
    await firstValueFrom(this.auth.ready.pipe(filter((x) => !!x)));
    const data = routeSnapshot.data as RouteData;

    const userSpecialties = this.auth.specialties;

    console.log(data.allowedSpecialties, userSpecialties);

    switch (this.compareArrays(data.allowedSpecialties ?? [], userSpecialties)) {
      case "partial":
      case "full":
        return true;
    }

    return this.router.createUrlTree(data.noAuthRedirectURL ? [data.noAuthRedirectURL] : ["error/403"]);
  }

  /**
   *
   * @param A
   * @param B
   * @returns
   */
  private compareArrays(A: unknown[], B: unknown[]): "disjoint" | "partial" | "full" {
    const matches: boolean[] = [];
    for (const AE of A) {
      matches.push(B.includes(AE));
    }

    if (A.length === B.length && matches.every((bool) => bool)) return "full";

    if (matches.some((bool) => bool)) return "partial";

    return "disjoint";
  }
}
